var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NxSelectReduced',{attrs:{"value":_vm.localValue,"options":_vm.listOptions,"labelText":"Sexo:","id":"selectSexo","placeholder":"Selecione o sexo","multiple":false,"isDisabled":_vm.isDisabled},on:{"update:value":_vm.handleValueUpdate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bc2f68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-selects/NxSelectSexo.vue
// module id = null
// module chunks = 